/**
 * Preference slider copy — spec v0.2 §2.2.
 *
 * The slider expresses appetite for detour, not a promise about the route:
 * it is `p_user` in `p_eff = p_user × f_W`, and the weather owns `f_W`.
 * That is why the labels never guarantee shade — on a cool overcast day the
 * router will rationally decline to chase it, and `dampedLabel` is what the
 * UI says instead (§7.3's shared "shade isn't the objective" state).
 */

export interface PrefStep {
  /** Lower bound of the slider range this label covers. */
  from: number
  label: string
}

export const PREF_STEPS: PrefStep[] = [
  { from: 0.0, label: 'Straight there' },
  { from: 0.25, label: 'A bit cooler' },
  { from: 0.55, label: 'Through the shade' },
  { from: 0.85, label: 'Anything but sun' },
]

export function prefLabel(value: number): string {
  let label = PREF_STEPS[0].label
  for (const step of PREF_STEPS) {
    if (value >= step.from) label = step.label
  }
  return label
}

/**
 * Shown when the weather factor is low, the sun is below ~10°, it is night,
 * or the date falls outside the seasonal shadow sets. All four collapse to
 * least-effort routing, so they collapse to one message.
 */
export const DAMPED_LABEL = "It's cool out — going direct."
